import {
  fetchOncologySubmissionData,
  OncologySubmissionApiResponse,
} from "../../../api/bigQuery/oncologySubmissionOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { logError } from "../../../utils/customLogger";
import { OncologySubmissionFilterPayload } from "../hooks/useFilterPayload";
import { OncologySubmissionTableState } from "../hooks/useOncologySubmissionTableData";

/**
 * makePostCallForInitialDataFetch - API Call for Initial Load
 *
 * Purpose: Fetches initial data when component mounts.
 * This is called once on component mount to load the first page of data.
 *
 * @param payload - Filter payload containing search params
 * @param setOncologySubmissionState - State setter for API response
 * @param setTableData - State setter for table data
 */
export const makePostCallForInitialDataFetch = async (
  payload: OncologySubmissionFilterPayload,
  setOncologySubmissionState: React.Dispatch<
    React.SetStateAction<OncologySubmissionTableState>
  >,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
): Promise<void> => {
  try {
    setOncologySubmissionState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    const response: OncologySubmissionApiResponse =
      await fetchOncologySubmissionData(payload);

    if (response.success) {
      setOncologySubmissionState({
        data: response,
        loading: false,
        error: null,
        showInlineLoader: false,
      });
      setTableData(response.rows);
    } else {
      setOncologySubmissionState((prev) => ({
        ...prev,
        loading: false,
        error: response.message || "Failed to fetch data",
      }));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    setOncologySubmissionState((prev) => ({
      ...prev,
      loading: false,
      error: errorMessage,
    }));
    logError(error as Error, "Error in makePostCallForInitialDataFetch");
  }
};
